import {curry} from 'ramda';
import {Marker} from '@accurate-player/accurate-player-components-external';

import {
    TimelineRow,
    TimelineMarker,
    MarkerOrUndefined,
} from 'VideoAudioQC/Timeline/TimelineTypes';

const getSelection = (rowData: TimelineRow, selectedMarkerId: string, selectedRowId: string): Marker[] => {
    const selectedMarker: MarkerOrUndefined = getSelectedMarker(rowData, selectedMarkerId, selectedRowId);
    const selection: Marker[] = [];
    
    if (selectedMarker) {
        const marker = new Marker(selectedMarker);
        selection.push(marker);
    }
    
    return selection;
};

const getSelectedMarker = (rowData: TimelineRow, selectedMarkerId: string, selectedRowId: string): MarkerOrUndefined => {
    const {
        identifier,
        markers,
    } = rowData;
    
    if (identifier !== selectedRowId) {
        return;
    }
    
    const findSelectedMarker = findMarker(selectedMarkerId);
    const selectedMarker = markers.find(findSelectedMarker);
    
    return selectedMarker;
};

const findMarker = curry((selectedMarkerId: string, marker: TimelineMarker) => {
    return selectedMarkerId === marker.identifier;
});

export default getSelection;
